import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';
import { DRenta210v18Servicios } from '@dian-api/renta210v18';
import { DStorageAzureServicios } from '@dian-api/storage-azure';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DRutServicios } from '@dian/api-rut';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { DContextoMuisca } from '@dian/core';
const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_143';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Deudas hipotecarias', listHelp: ['651','652','653','654','655','656'] }
];

const tableStructure = [   
  {id: 'origen', title: 'Origen de la información'}, 
  {id: 'montoFacturasValidas', title: 'Monto de factura validas deducciones de 1%'}, 
  {id: 'valDeduccion', title: 'Valor deducción'},
];

class ValoresDominio {
  valor: string;
  nombre: string;
  mostrar: boolean;
}

class Form1 {
  id: number;
  idSugerida:number;
  origen:string;  
  valDeduccion:string;
  montoMaxSusceptibleBeneficio: string;  
  montoFacturasValidas:string;
  adquisicionNombre:string; 
  reportante:string; 
}

class Form2 {
  anio:number;
  tipoDocumento:string;
  nit:string;  
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-beneficios-compras-factura-electronica-modal',
  templateUrl: './beneficios-compras-factura-electronica-modal.component.html',
  styleUrls: ['./beneficios-compras-factura-electronica-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DValorDominio,
    DRenta210v18Servicios,
    DStorageAzureServicios,
    DContextoUsuarioServicio,
    DRutServicios
  ]
})
export class BeneficiosComprasFacturaElectronicaModalComponent extends HandlerModal implements OnInit {
  //[x: string]: any;

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  public valorUVT: any;
  public parameFact: Form2 = new Form2();
  public tiposDocumento: ValoresDominio[] = [];
  public montoMaxBeneficio:string = "0";

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA; 
  
  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  private infoFactCarga=false;
  
  
  
  mensajeTabla = "El monto de facturas válidas para deducción del 1% es sugerida por validación de la DIAN sobre el reporte del sistema de factura electrónica.  Usted podrá editar esta cifra y el sistema recalculará el porcentaje de la deducción."
  +"          Consulte en el botón “Descargar detalle” todas las facturas electrónicas registradas ante la DIAN.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  model: DDocumento;
  montoSugFacturasValidas: string;
  
  constructor(
    public dutilidades:DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio, 
    public dialogRef: MatDialogRef<BeneficiosComprasFacturaElectronicaModalComponent>,
    private dServicioRESTAPI: DRenta210v18Servicios,
    private dStorageAzureServicios: DStorageAzureServicios,
    private dContextoUsuario: DContextoUsuarioServicio,
    private _sugeridaSingletonService: SugeridaSingletonService,
    private dRutServicios: DRutServicios,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO,); 
    this.model = this.data.model;   
    console.log(this.model);

  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeFacturaSugerida();
  }

  public descargarFacturaElectronica(){
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();

    this.dContextoUsuario.consultarContextoUsuarioMuisca().subscribe(
      (res: DContextoMuisca) => {
        const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
        if (!contexto) {
          console.log("Error obteniendo el contexto para la consulta de FE");
          precargaProceso.close();
          return;
        }

        let resTipoDocumento:String = String(res.codigoUsuario);
        let codTipoDocumento = resTipoDocumento.substring(0,2);//El tipo de documento son los primeros dígitos del codUsuario
        this.dStorageAzureServicios.descargaFacturaElectronicaBlobStorage(String(this.model.doc.cab.cs_id_1), codTipoDocumento, res.NitUsuario)
          .subscribe(
            (res: any) => {
              if (!res) {
                console.log("El servicio Obtener Facturas Electrónica responde pero no se obtienen datos");
                precargaProceso.close();
                return;
              }
              
              let blob = new Blob([res.blob], {type: 'application/xlsx'});
              window['saveAs'](blob, "report.xlsx");
              precargaProceso.close();

            }, error => {
              console.log("Servicio cargar Obtener Facturas Electrónica ejecutado con error. 2 " + error.mensaje);
              let dialogError = this.dNotificacionServicio.mostrarDialogoError("Se presentó un error obteniendo los datos de Factura Electrónica" );
              precargaProceso.close();
            }
          );
      }, error => {
        console.log("Servicio cargar Obtener Facturas Electrónica ejecutado con error. 2 " + error.mensaje);
        let dialogError = this.dNotificacionServicio.mostrarDialogoError("Se presentó un error obteniendo los datos de Factura Electrónica" );
        precargaProceso.close();
      }
    );  


  }

    
  
  public obtenerFacturas(): Promise<void> {
    return new Promise((resolve, reject) => {
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dRutServicios.consultarIdentificacion(this.model.doc.cab.cs_id_5).subscribe(
        data => {
          console.log("consultarTipoDocumento");
          console.log(data);
          let nombreTipoDocumento = data.tipoDocumento.nombre;
   
          for (let tipoDoc of this.tiposDocumento) {
            if (nombreTipoDocumento == (tipoDoc.nombre)) {
              console.log("El tipo de documento obtenido es: " + tipoDoc.valor);
              this.parameFact.tipoDocumento = tipoDoc.valor;
              this.parameFact.nit = data.nit;
              this.parameFact.anio = this.model.doc.cab.cs_id_1;
            }
          }
          precargaProceso.close();
          resolve();
          return;
        },
        error => {
          console.log("Error Obtener tipo de documento ejecutado con error. " + error.mensaje);
          let dialogError = this.dNotificacionServicio.mostrarDialogoError("Se presentó un error obteniendo datos de identificación del usuario" );
          precargaProceso.close();
          reject(error);
        }
      )
      this.operacionCs656();
    });
  }

  protected controlStep(direction: DirectionType): void {
  
  }
  
  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;    
    this.modelForm.montoMaxSusceptibleBeneficio = this.montoMaxBeneficio;
    this.modelForm.adquisicionNombre="";
    this.modelForm.origen = "0";
    this.modelForm.valDeduccion = "0";    
    this.modelForm.idSugerida = 0;    
    this.modelForm.montoFacturasValidas="0";    
    this.modelForm.reportante="";     
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_653 == undefined) {
      
      this.model.doc.cuerpo.cc_id_652 = [];   //Origen
      this.model.doc.cuerpo.cc_id_653 = [];   //Monto de facturas válidas deducción 1%. montoTotalFacTrasAjustes
      this.model.doc.cuerpo.cc_id_654 = [];   //Valor Deducción
      this.model.doc.cuerpo.cc_id_655 = [];   //Valor Monto máximo (Casilla Oculta). montoMaxSusceptibleBeneficio       
      this.model.doc.cuerpo.cs_id_656 = "0";  //Valor Total Deducción      
    }    
  }




  public operacionCs656(){ 
    let suma = "0";
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.dataSourceBody[i].valDeduccion, suma);
    }
    this.model.doc.cuerpo.cs_id_656 = this.dutilidades.redondearValorMoneda(suma.toString(),true);
  }


  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_653.length; i++){
      this.modelForm.id=i;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_652[i].v;           
      this.modelForm.montoFacturasValidas=this.model.doc.cuerpo.cc_id_653[i].v;       
      this.modelForm.valDeduccion=this.model.doc.cuerpo.cc_id_654[i].v;
      //this.modelForm.desc=this.model.doc.cuerpo.cc_id_655;      
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeFacturaSugerida(){
  
    let indexModel = this.model.doc.cuerpo.cc_id_653.length;

    if(indexModel==0){
      const fieldsRecovery = ['VAR_FE','VAR_FE_1'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);
    
      if(resData)
      {
        this.modelForm.id=indexModel;
        this.modelForm.origen="0";

        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
            if(resData[i].key=="VAR_FE"){
              /* let deducccion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,String(resData[i].item.value[j]), "0.01");
              this.modelForm.valDeduccion=deducccion;  */
              this.montoSugFacturasValidas = String(resData[i].item.value[j]);
            }
            if(resData[i].key=="VAR_FE_1"){
              let deducccion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,String(resData[i].item.value[j]), "0.01");
              this.modelForm.valDeduccion=deducccion;
              this.montoMaxBeneficio=String(resData[i].item.value[j]);
              this.modelForm.montoFacturasValidas = this.montoMaxBeneficio;
            }
            indexModel++;
          }
        }
        
        this.redondearFormData();
        this.dataSourceBody.push(this.modelForm);
        this.inicializeForm();
        
      }
    }
      console.log(this.modelForm.valDeduccion);
      this.operacionCs656();
  } 

  public editModeloDesdeForm(){   
    
    //this.model.doc.cuerpo.cs_id_653=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_652[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_653[this.modelForm.id].v=this.modelForm.montoFacturasValidas.toString();       
    this.model.doc.cuerpo.cc_id_654[this.modelForm.id].v=this.modelForm.valDeduccion.toString();
    this.model.doc.cuerpo.cs_id_656=this.modelForm.valDeduccion.toString();

  }

  public addToModeloDesdeForm(){
     
    //this.model.doc.cuerpo.cc_id_653.push(this.modelForm.desc);
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_652.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_653.push({it: i, v:this.modelForm.montoFacturasValidas.toString()});    
    this.model.doc.cuerpo.cc_id_654.push({it: i, v:this.modelForm.valDeduccion.toString()});
    

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_652.splice(index,1); 
    this.model.doc.cuerpo.cc_id_653.splice(index,1);
    this.model.doc.cuerpo.cc_id_654.splice(index,1);
    this.model.doc.cuerpo.cs_id_656="0";

    //reenumerear it
  for(let i=0;i<this.model.doc.cuerpo.cc_id_653.length;i++){
      this.model.doc.cuerpo.cc_id_653[i].it=i+1;
      this.model.doc.cuerpo.cc_id_652[i].it=i+1;
      this.model.doc.cuerpo.cc_id_654[i].it=i+1;           
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.montoFacturasValidas==undefined || this.modelForm.montoFacturasValidas==null || this.modelForm.montoFacturasValidas.trim()=="" ||
          this.modelForm.valDeduccion==undefined || this.modelForm.valDeduccion==null
          
  }

  public redondearFormData(){       
    this.modelForm.montoFacturasValidas=this.dutilidades.redondearValorMoneda(this.modelForm.montoFacturasValidas.toString(),true);
    this.modelForm.valDeduccion=this.dutilidades.redondearValorMoneda(this.modelForm.valDeduccion.toString(),true);
  }

  public calcularValoresForm(){
    this.redondearFormData();
    let deducccion = "0";
    
    this.modelForm.montoFacturasValidas = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,this.modelForm.montoFacturasValidas,this.montoSugFacturasValidas)?this.modelForm.montoFacturasValidas:this.montoSugFacturasValidas;
    let montoMaxUVT=this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.valorUVT,"240"); //"11295600";
    deducccion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.montoFacturasValidas, "0.01");    
    let valorDeduccion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,deducccion,montoMaxUVT)?deducccion:montoMaxUVT;
    this.modelForm.valDeduccion=this.dutilidades.redondearValorMoneda(valorDeduccion.toString(),true);
  }




  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        const existeValor = this.model.doc.cuerpo.cc_id_653.some(item => item.v === this.modelForm.montoFacturasValidas);
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
        
       // this.editModeloDesdeForm();      
       }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
         this.modelForm.id = this.model.doc.cuerpo.cc_id_653.length;
         this.modelForm.origen = "2";
         this.modelForm.reportante = "Contribuyente";        
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs656();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs656();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      //this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }



  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs656();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_653 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs656();
    this.saveModel.emit(true); 
    //if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    //} 
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-compras-factura-electronica/beneficios-compras-factura-electronica-modal.component.ts